module.exports = __webpack_public_path__ + "img/sec16desk.270ea76f.png";